module.exports = require("core-js/library/fn/map");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/map.js
// module id = 147
// module chunks = 35783957827783 70144966829960 114276838955818 198517197184460